import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { InviteMemberDto } from '../pages/community-members/invite-member/invite-member-dto.model';

@Injectable({
    providedIn: 'root',
})
export class CommunityMemberApiService {
    private communityApiUrl = `${environment.microservices.identity.baseUrl}/${environment.microservices.identity.communitiesApi.baseUrl}`;

    constructor(private readonly http: HttpClient) {}

    public inviteMember(memberDto: InviteMemberDto): Observable<void> {
        return this.http.post<void>(`${this.communityApiUrl}/invite`, memberDto);
    }
}

